import { zodMessages, zodValidateMinMax } from '@/shared/config/zod/schema'
import { z } from 'zod'

export const ChangePasswordSchema = z
  .object({
    newPassword: zodValidateMinMax(6, 1000),
    newPassword2: zodValidateMinMax(6, 1000),
    link: z.string(),
  })
  .refine(
    (values) => {
      return values.newPassword === values.newPassword2
    },
    {
      message: zodMessages.passwordShouldMatch,
      path: 'newPassword2' as any,
    },
  )
